import Vue from 'vue'
import Vuex from 'vuex'
import Meta from 'vue-meta'
import ClientOnly from 'vue-client-only'
import NoSsr from 'vue-no-ssr'
import { createRouter } from './router.js'
import NuxtChild from './components/nuxt-child.js'
import NuxtError from '../layouts/error.vue'
import Nuxt from './components/nuxt.js'
import App from './App.js'
import { setContext, getLocation, getRouteData, normalizeError } from './utils'
import { createStore } from './store.js'

/* Plugins */

import nuxt_plugin_plugin_73851074 from 'nuxt_plugin_plugin_73851074' // Source: ./components/plugin.js (mode: 'all')
import nuxt_plugin_sentryserver_61fc4164 from 'nuxt_plugin_sentryserver_61fc4164' // Source: ./sentry.server.js (mode: 'server')
import nuxt_plugin_sentryclient_69486dc6 from 'nuxt_plugin_sentryclient_69486dc6' // Source: ./sentry.client.js (mode: 'client')
import nuxt_plugin_vuesocialsharingplugin_82ff48fa from 'nuxt_plugin_vuesocialsharingplugin_82ff48fa' // Source: ./vue-social-sharing-plugin.js (mode: 'all')
import nuxt_plugin_pluginutils_0d8029f1 from 'nuxt_plugin_pluginutils_0d8029f1' // Source: ./nuxt-i18n/plugin.utils.js (mode: 'all')
import nuxt_plugin_pluginrouting_641dfefc from 'nuxt_plugin_pluginrouting_641dfefc' // Source: ./nuxt-i18n/plugin.routing.js (mode: 'all')
import nuxt_plugin_pluginmain_5197adf3 from 'nuxt_plugin_pluginmain_5197adf3' // Source: ./nuxt-i18n/plugin.main.js (mode: 'all')
import nuxt_plugin_axios_4105498a from 'nuxt_plugin_axios_4105498a' // Source: ./axios.js (mode: 'all')
import nuxt_plugin_axios_2228ef02 from 'nuxt_plugin_axios_2228ef02' // Source: ../plugins/axios (mode: 'all')
import nuxt_plugin_api_caeae0b4 from 'nuxt_plugin_api_caeae0b4' // Source: ../plugins/api (mode: 'all')
import nuxt_plugin_fmt_caeabbce from 'nuxt_plugin_fmt_caeabbce' // Source: ../plugins/fmt (mode: 'all')
import nuxt_plugin_elementui_d905880e from 'nuxt_plugin_elementui_d905880e' // Source: ../plugins/element-ui (mode: 'all')
import nuxt_plugin_veevalidate_346f6561 from 'nuxt_plugin_veevalidate_346f6561' // Source: ../plugins/vee-validate (mode: 'all')
import nuxt_plugin_init_600fa816 from 'nuxt_plugin_init_600fa816' // Source: ../plugins/init.client (mode: 'client')
import nuxt_plugin_bvispeech_403034aa from 'nuxt_plugin_bvispeech_403034aa' // Source: ../plugins/bvi-speech.client (mode: 'client')
import nuxt_plugin_bviimages_a82ad156 from 'nuxt_plugin_bviimages_a82ad156' // Source: ../plugins/bvi-images.client (mode: 'client')
import nuxt_plugin_metrika_0716042c from 'nuxt_plugin_metrika_0716042c' // Source: ../plugins/integrations/metrika.client (mode: 'client')
import nuxt_plugin_gtm_78386256 from 'nuxt_plugin_gtm_78386256' // Source: ../plugins/integrations/gtm.client (mode: 'client')
import nuxt_plugin_tiktok_a763e17a from 'nuxt_plugin_tiktok_a763e17a' // Source: ../plugins/integrations/tiktok.client (mode: 'client')
import nuxt_plugin_mail_2dc7e634 from 'nuxt_plugin_mail_2dc7e634' // Source: ../plugins/integrations/mail.client (mode: 'client')
import nuxt_plugin_telegram_eb54bf48 from 'nuxt_plugin_telegram_eb54bf48' // Source: ../plugins/integrations/telegram.client (mode: 'client')
import nuxt_plugin_vkpixel_0f556962 from 'nuxt_plugin_vkpixel_0f556962' // Source: ../plugins/integrations/vk-pixel.client (mode: 'client')
import nuxt_plugin_gtag_38ac2d6c from 'nuxt_plugin_gtag_38ac2d6c' // Source: ../plugins/integrations/gtag.client (mode: 'client')
import nuxt_plugin_auth_60aa0666 from 'nuxt_plugin_auth_60aa0666' // Source: ./auth.js (mode: 'all')
import nuxt_plugin_authi18n_2ba9f270 from 'nuxt_plugin_authi18n_2ba9f270' // Source: ../plugins/auth/auth-i18n (mode: 'all')
import nuxt_plugin_authuser_38cacabc from 'nuxt_plugin_authuser_38cacabc' // Source: ../plugins/auth/auth-user.client (mode: 'client')

// Component: <ClientOnly>
Vue.component(ClientOnly.name, ClientOnly)

// TODO: Remove in Nuxt 3: <NoSsr>
Vue.component(NoSsr.name, {
  ...NoSsr,
  render (h, ctx) {
    if (process.client && !NoSsr._warned) {
      NoSsr._warned = true

      console.warn('<no-ssr> has been deprecated and will be removed in Nuxt 3, please use <client-only> instead')
    }
    return NoSsr.render(h, ctx)
  }
})

// Component: <NuxtChild>
Vue.component(NuxtChild.name, NuxtChild)
Vue.component('NChild', NuxtChild)

// Component NuxtLink is imported in server.js or client.js

// Component: <Nuxt>
Vue.component(Nuxt.name, Nuxt)

Object.defineProperty(Vue.prototype, '$nuxt', {
  get() {
    const globalNuxt = this.$root ? this.$root.$options.$nuxt : null
    if (process.client && !globalNuxt && typeof window !== 'undefined') {
      return window.$nuxt
    }
    return globalNuxt
  },
  configurable: true
})

Vue.use(Meta, {"keyName":"head","attribute":"data-n-head","ssrAttribute":"data-n-head-ssr","tagIDKeyName":"hid"})

const defaultTransition = {"name":"page","mode":"out-in","appear":false,"appearClass":"appear","appearActiveClass":"appear-active","appearToClass":"appear-to"}

const originalRegisterModule = Vuex.Store.prototype.registerModule

function registerModule (path, rawModule, options = {}) {
  const preserveState = process.client && (
    Array.isArray(path)
      ? !!path.reduce((namespacedState, path) => namespacedState && namespacedState[path], this.state)
      : path in this.state
  )
  return originalRegisterModule.call(this, path, rawModule, { preserveState, ...options })
}

async function createApp(ssrContext, config = {}) {
  const store = createStore(ssrContext)
  const router = await createRouter(ssrContext, config, { store })

  // Add this.$router into store actions/mutations
  store.$router = router

  // Fix SSR caveat https://github.com/nuxt/nuxt.js/issues/3757#issuecomment-414689141
  store.registerModule = registerModule

  // Create Root instance

  // here we inject the router and store to all child components,
  // making them available everywhere as `this.$router` and `this.$store`.
  const app = {
    head: {"htmlAttrs":{"lang":"ru"},"meta":[{"charset":"utf-8"},{"name":"viewport","content":"width=device-width, initial-scale=1, maximum-scale=5"}],"link":[{"rel":"preload","as":"font","crossorigin":"crossorigin","type":"font\u002Fttf","href":"\u002Ffonts\u002FOnest\u002FOnest-Variable.ttf"},{"rel":"stylesheet","href":"\u002Fvendor\u002Fbvi\u002Fcss\u002Fbvi.min.css"}],"style":[],"script":[]},

    store,
    router,
    nuxt: {
      defaultTransition,
      transitions: [defaultTransition],
      setTransitions (transitions) {
        if (!Array.isArray(transitions)) {
          transitions = [transitions]
        }
        transitions = transitions.map((transition) => {
          if (!transition) {
            transition = defaultTransition
          } else if (typeof transition === 'string') {
            transition = Object.assign({}, defaultTransition, { name: transition })
          } else {
            transition = Object.assign({}, defaultTransition, transition)
          }
          return transition
        })
        this.$options.nuxt.transitions = transitions
        return transitions
      },

      err: null,
      errPageReady: false,
      dateErr: null,
      error (err) {
        err = err || null
        app.context._errored = Boolean(err)
        err = err ? normalizeError(err) : null
        let nuxt = app.nuxt // to work with @vue/composition-api, see https://github.com/nuxt/nuxt.js/issues/6517#issuecomment-573280207
        if (this) {
          nuxt = this.nuxt || this.$options.nuxt
        }
        nuxt.dateErr = Date.now()
        nuxt.err = err
        nuxt.errPageReady = false
        // Used in src/server.js
        if (ssrContext) {
          ssrContext.nuxt.error = err
        }
        return err
      }
    },
    ...App
  }

  // Make app available into store via this.app
  store.app = app

  const next = ssrContext ? ssrContext.next : location => app.router.push(location)
  // Resolve route
  let route
  if (ssrContext) {
    route = router.resolve(ssrContext.url).route
  } else {
    const path = getLocation(router.options.base, router.options.mode)
    route = router.resolve(path).route
  }

  // Set context to app.context
  await setContext(app, {
    store,
    route,
    next,
    error: app.nuxt.error.bind(app),
    payload: ssrContext ? ssrContext.payload : undefined,
    req: ssrContext ? ssrContext.req : undefined,
    res: ssrContext ? ssrContext.res : undefined,
    beforeRenderFns: ssrContext ? ssrContext.beforeRenderFns : undefined,
    beforeSerializeFns: ssrContext ? ssrContext.beforeSerializeFns : undefined,
    ssrContext
  })

  function inject(key, value) {
    if (!key) {
      throw new Error('inject(key, value) has no key provided')
    }
    if (value === undefined) {
      throw new Error(`inject('${key}', value) has no value provided`)
    }

    key = '$' + key
    // Add into app
    app[key] = value
    // Add into context
    if (!app.context[key]) {
      app.context[key] = value
    }

    // Add into store
    store[key] = app[key]

    // Check if plugin not already installed
    const installKey = '__nuxt_' + key + '_installed__'
    if (Vue[installKey]) {
      return
    }
    Vue[installKey] = true
    // Call Vue.use() to install the plugin into vm
    Vue.use(() => {
      if (!Object.prototype.hasOwnProperty.call(Vue.prototype, key)) {
        Object.defineProperty(Vue.prototype, key, {
          get () {
            return this.$root.$options[key]
          }
        })
      }
    })
  }

  // Inject runtime config as $config
  inject('config', config)

  if (process.client) {
    // Replace store state before plugins execution
    if (window.__NUXT__ && window.__NUXT__.state) {
      store.replaceState(window.__NUXT__.state)
    }
  }

  // Add enablePreview(previewData = {}) in context for plugins
  if (process.static && process.client) {
    app.context.enablePreview = function (previewData = {}) {
      app.previewData = Object.assign({}, previewData)
      inject('preview', previewData)
    }
  }
  // Plugin execution

  if (typeof nuxt_plugin_plugin_73851074 === 'function') {
    await nuxt_plugin_plugin_73851074(app.context, inject)
  }

  if (process.server && typeof nuxt_plugin_sentryserver_61fc4164 === 'function') {
    await nuxt_plugin_sentryserver_61fc4164(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_sentryclient_69486dc6 === 'function') {
    await nuxt_plugin_sentryclient_69486dc6(app.context, inject)
  }

  if (typeof nuxt_plugin_vuesocialsharingplugin_82ff48fa === 'function') {
    await nuxt_plugin_vuesocialsharingplugin_82ff48fa(app.context, inject)
  }

  if (typeof nuxt_plugin_pluginutils_0d8029f1 === 'function') {
    await nuxt_plugin_pluginutils_0d8029f1(app.context, inject)
  }

  if (typeof nuxt_plugin_pluginrouting_641dfefc === 'function') {
    await nuxt_plugin_pluginrouting_641dfefc(app.context, inject)
  }

  if (typeof nuxt_plugin_pluginmain_5197adf3 === 'function') {
    await nuxt_plugin_pluginmain_5197adf3(app.context, inject)
  }

  if (typeof nuxt_plugin_axios_4105498a === 'function') {
    await nuxt_plugin_axios_4105498a(app.context, inject)
  }

  if (typeof nuxt_plugin_axios_2228ef02 === 'function') {
    await nuxt_plugin_axios_2228ef02(app.context, inject)
  }

  if (typeof nuxt_plugin_api_caeae0b4 === 'function') {
    await nuxt_plugin_api_caeae0b4(app.context, inject)
  }

  if (typeof nuxt_plugin_fmt_caeabbce === 'function') {
    await nuxt_plugin_fmt_caeabbce(app.context, inject)
  }

  if (typeof nuxt_plugin_elementui_d905880e === 'function') {
    await nuxt_plugin_elementui_d905880e(app.context, inject)
  }

  if (typeof nuxt_plugin_veevalidate_346f6561 === 'function') {
    await nuxt_plugin_veevalidate_346f6561(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_init_600fa816 === 'function') {
    await nuxt_plugin_init_600fa816(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_bvispeech_403034aa === 'function') {
    await nuxt_plugin_bvispeech_403034aa(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_bviimages_a82ad156 === 'function') {
    await nuxt_plugin_bviimages_a82ad156(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_metrika_0716042c === 'function') {
    await nuxt_plugin_metrika_0716042c(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_gtm_78386256 === 'function') {
    await nuxt_plugin_gtm_78386256(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_tiktok_a763e17a === 'function') {
    await nuxt_plugin_tiktok_a763e17a(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_mail_2dc7e634 === 'function') {
    await nuxt_plugin_mail_2dc7e634(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_telegram_eb54bf48 === 'function') {
    await nuxt_plugin_telegram_eb54bf48(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_vkpixel_0f556962 === 'function') {
    await nuxt_plugin_vkpixel_0f556962(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_gtag_38ac2d6c === 'function') {
    await nuxt_plugin_gtag_38ac2d6c(app.context, inject)
  }

  if (typeof nuxt_plugin_auth_60aa0666 === 'function') {
    await nuxt_plugin_auth_60aa0666(app.context, inject)
  }

  if (typeof nuxt_plugin_authi18n_2ba9f270 === 'function') {
    await nuxt_plugin_authi18n_2ba9f270(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_authuser_38cacabc === 'function') {
    await nuxt_plugin_authuser_38cacabc(app.context, inject)
  }

  // Lock enablePreview in context
  if (process.static && process.client) {
    app.context.enablePreview = function () {
      console.warn('You cannot call enablePreview() outside a plugin.')
    }
  }

  // Wait for async component to be resolved first
  await new Promise((resolve, reject) => {
    // Ignore 404s rather than blindly replacing URL in browser
    if (process.client) {
      const { route } = router.resolve(app.context.route.fullPath)
      if (!route.matched.length) {
        return resolve()
      }
    }
    router.replace(app.context.route.fullPath, resolve, (err) => {
      // https://github.com/vuejs/vue-router/blob/v3.4.3/src/util/errors.js
      if (!err._isRouter) return reject(err)
      if (err.type !== 2 /* NavigationFailureType.redirected */) return resolve()

      // navigated to a different route in router guard
      const unregister = router.afterEach(async (to, from) => {
        if (process.server && ssrContext && ssrContext.url) {
          ssrContext.url = to.fullPath
        }
        app.context.route = await getRouteData(to)
        app.context.params = to.params || {}
        app.context.query = to.query || {}
        unregister()
        resolve()
      })
    })
  })

  return {
    store,
    app,
    router
  }
}

export { createApp, NuxtError }
